export default {
  topbarHeight: '0px',
  warningBarHeight: '0px',
  bottomBarHeight: '0px',
  sidebarWidth: '0px',
  contentMaxWidth: '100%',
  rootMaxWidth: '1280px',

  // HRDF specific:
  hrdfSectionGap: '0px',
} as const;
